export default "__VITE_ASSET__8f4293b0__"